export default __webpack_public_path__ + "static/media/Logo_App_Manager.6ac998b2.png";